import { useEffect } from 'react';

import reportRequestError from '~services/reportRequestError';

export default function useReportRequestError({
  error,
  errorUpdatedAt,
  message,
  shouldReport,
}: {
  error: unknown;
  errorUpdatedAt: number;
  message: string;
  shouldReport: boolean;
}) {
  useEffect(() => {
    if (!shouldReport) return;

    reportRequestError(error, message);
  }, [error, errorUpdatedAt, message, shouldReport]);
}
